<template>
  <div id="education-job-link-template" class="modal__wrap--bg cmp-modal" :class="{'is-active' : showModal}"
       role="dialog" aria-modal="true" aria-labelledby="joblink-modal-title">
    <div class="modal-wrap-container modal-wd1020" ref="modalContainer" tabindex="-1">
      <div class="modal-header">
        <div class="title" id="joblink-modal-title">교육 연계 공고</div>
      </div>
      <div class="modal-body-container ht-full">
        <div class="table-wrap no-line-mg">
          <table class="table-body-only">
            <caption>교육 연계 공고 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">강좌명</th>
                <td>{{ title }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="job-list-container">
          <div class="no-data" v-if="totalCount === 0">해당 교육과 연계된 공고가 없습니다.</div>
          <div class="job-card-grid grid-3" v-else>
            <JobCard
              v-for="(item, index) in normalizedList"
              :key="index"
              :item="item"
              @favorite-toggle="toggleFavorite"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150  close-modal" @click="close">
         닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import JobCard from '../components/JobCard.vue';

const WorkConditionCode = {
  IN60001: '정규직',
  IN60002: '계약직',
  IN60003: '인턴직',
  IN60004: '파트타임',
  IN60005: '기타',
};

const CareerHistoryCode = {
  ANY: '경력무관',
  NEW: '신입',
  EXPERIENCED: '경력',
};

export default {
  name: 'education-job-link-template',
  props: ['educationJobLinkModal', 'lectureNo', 'title', 'isLogin'],
  components: {
    JobCard,
  },
  data() {
    return {
      showModal: false,
      list: [],
      totalCount: 0,
      WorkConditionCode,
      CareerHistoryCode,
    };
  },
  computed: {
    normalizedList() {
      return this.list.map(item => ({
        ...item,
        // JobCard가 기대하는 필드명으로 변환
        ANN_NM: item.ANN_NM,
        BIZ_SE: item.BIZ_SE,
        BIZ_SE_NM: item.BIZ_SE_NM,
        OPER_ORG_NM: item.OPER_ORG_NM,
        rcptPpl: item.rcptPpl,
        APPDURNG_STED: item.APPDURNG_STED,
        FAVORITE_YN: item.isFavorite ? 'Y' : 'N',
        DDAY: item.DDAY,
        ANN_RCRT_STAT: item.ANN_RCRT_STAT,
        // 추가 필드들
        actamtHamt: item.actamtHamt,
        workConditionLabel: item.workConditionLabel,
      }));
    },
  },
  watch: {
    educationJobLinkModal: {
      handler(newVal) {
        if (newVal) {
          this.getList();
          this.showModal = true;
          // 모달로 포커스 이동
          this.$nextTick(() => {
            if (this.$refs.modalContainer) {
              this.$refs.modalContainer.focus();
            }
          });
        } else {
          this.showModal = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getList() {
      Axios.get(`/api/anns/byLecture/${this.lectureNo}`)
        .then((response) => {
          const jobList = response.data.data.map(job => ({
            ...job,
            annType: (job.BIZ_SE.includes('JB')) ? 'JB' : 'IN',
            viewUrl: (job.BIZ_SE.includes('JB'))
              ? `/appView.do?ANN_NO=${job.ANN_NO}`
              : `/in_appView.do?ANN_NO=${job.ANN_NO}`,
            rcptPpl: job.RCRT_PPL.toLocaleString('ko-KR'),
            actamtHamt: job.ACTAMT_HAMT.toLocaleString('ko-KR'),
            workConditionLabel: (!job.WORK_CONDITION) ? this.WorkConditionCode[job.WORK_CONDITION] : '',
            careerHistoryLabel: (!job.CAREER_HISTORY) ? this.CareerHistoryCode[job.CAREER_HISTORY] : '',
            isFavorite: job.FAVORITE_YN === 'Y',
          }));
          this.list = jobList;
          this.totalCount = this.list.length;
        }).catch((error) => {
          console.log(error.data);
        });
    },
    toggleFavorite(item) {
      if (!this.isLogin) {
        alert('로그인 후 이용 가능합니다.');
        return;
      }

      const confirmText = item.isFavorite ? '취소' : '등록';
      if (!confirm(`해당 공고를 관심 ${confirmText}하시겠습니까?`)) {
        return;
      }

      const method = item.isFavorite ? 'DELETE' : 'POST';
      Axios({
        url: `/api/favorite-anns/${item.annType}/${item.ANN_NO}`,
        method,
      }).then(() => {
        const index = this.list.findIndex(listItem => listItem.ANN_NO === item.ANN_NO);
        if (index !== -1) {
          this.list[index].isFavorite = !this.list[index].isFavorite;
        }
      }).catch((error) => {
        const errorMessage = (error.response && error.response.data && error.response.data.message) || '처리 중 오류가 발생했습니다. 다시 시도해 주세요.';
        alert(errorMessage);
      });
    },
    close() {
      this.showModal = false;
      this.list = [];
      this.$emit('update:educationJobLinkModal', false);
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// EducationJobLink.vue?fbbd1812